import { Offcanvas } from 'bootstrap';

export default (function ( window, document, undefined ) {
  const Headroom = require('./_headroom');
  window.addEventListener('load', function () {
    const header = document.querySelector('[data-sticky-header]');
    if (header) {
        document.documentElement.dataset.withStickyHeader = true;

        const headroom = new Headroom(header, {
        classes: {
          initial : "page-header",
          pinned : "page-header--pinned",
          unpinned : "page-header--unpinned",
        }
      });
      headroom.init();
    }
  });
})( window, document );
